/**
 * @fileOverview The main entry point to your standalone. Start editing here.
 */

import React from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/icon.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/grid.css'
import {
  VerticalTimeline,
  VerticalTimelineElement
} from 'react-vertical-timeline-component'
import 'react-vertical-timeline-component/style.min.css'
import './styles.scss'
import { ThemeSwitch } from '@ta-interaktiv/react-theme-switch'

// TODO Set the correct article ID here
const ARTICLE_ID = '00000000'

export function AppComponent() {
  return (
    <div className='index'>
      <ThemeSwitch />
      <VerticalTimeline layout='1-column' animate={false}>
        <VerticalTimelineElement
          className='milestone'
          contentStyle={{ background: 'rgb(255, 255, 255)', color: '#333' }}
          contentArrowStyle={{ borderRight: '7px solid  rgb(255, 255, 255)' }}
          iconStyle={{ background: 'rgb(255, 255, 255)', color: '#fff' }}
          icon={<i className='icon dot circle large green' />}
        >
          <h3 className='vertical-timeline-element-title'>27. April</h3>
          <h4 className='vertical-timeline-element-subtitle'>
            Dienstleistungen mit begrenztem Ansteckungsrisiko
          </h4>
          <p>
            Als Erstes gehen Geschäfte wieder auf, in denen die Anzahl direkter
            Kontakte gering ist, sich der Schutz einfach gewährleisten lässt und
            die keine grösseren Personenströme auslösen.
          </p>
          <h5>
            <i className='icon lock open green opened' />
            geöffnet werden
          </h5>
          <div className='ui equal width center aligned padded grid'>
            <div className='three column row'>
              <div className='column'>
                <img
                  src={require('./images/spital.svg')}
                  className='ui fluid image'
                />
                Spitäler, alle Eingriffe
              </div>
              <div className='column'>
                <img
                  src={require('./images/zahnarzt.svg')}
                  className='ui fluid image'
                />
                Arzt- und Zahnarztpraxen
              </div>
              <div className='column'>
                <img
                  src={require('./images/physio.svg')}
                  className='ui fluid image'
                />
                Physiotherapie, Massage
              </div>
            </div>
            <div className='three column row'>
              <div className='column'>
                <img
                  src={require('./images/coiffeur.svg')}
                  className='ui fluid image'
                />
                Coiffeur- und
                <br />
                Kosmetiksalons
              </div>
              <div className='column'>
                <img
                  src={require('./images/gaertnerei.svg')}
                  className='ui fluid image'
                />
                Gärtnereien,
                <br />
                Blumenläden
              </div>
              <div className='column'>
                <img
                  src={require('./images/baumarkt.svg')}
                  className='ui fluid image'
                />
                Bau- und Gartencenter
              </div>
            </div>
          </div>
          <p className='additional'>
            Öffnen kann nur, wer ein Schutzkonzept für Kundschaft und
            Angestellte vorweist.
          </p>
          <h5>
            <i className='icon lock red locked' />
            geschlossen bleiben
          </h5>
          <div className='ui equal width center aligned padded grid'>
            <div className='row'>
              <div className='column'>
                <img
                  src={require('./images/schule-locked.svg')}
                  className='ui fluid image'
                />
                Schulen
              </div>
              <div className='column'>
                <img
                  src={require('./images/restaurant-locked.svg')}
                  className='ui fluid image'
                />
                Restaurants
              </div>
            </div>
            <div className='row'>
              <div className='column'>
                <img
                  src={require('./images/markt-locked.svg')}
                  className='ui fluid image'
                />
                Einkaufsläden, Märkte
              </div>
              <div className='column'>
                <img
                  src={require('./images/veranstaltungen-locked.svg')}
                  className='ui fluid image'
                />
                Versammlungen > 5 Personen
              </div>
            </div>
          </div>
          <h5>
            <i className='icon exclamation triangle blue' />
            weiterhin gilt
          </h5>
          <div className='ui equal width center aligned padded grid'>
            <div className='three column row'>
              <div className='column'>
                <img
                  src={require('./images/abstand.svg')}
                  className='ui fluid image'
                />
                Abstand
                <br />
                halten
              </div>
              <div className='column'>
                <img
                  src={require('./images/haendewaschen.svg')}
                  className='ui fluid image'
                />
                Hygiene beachten
              </div>
              <div className='column'>
                <img
                  src={require('./images/zuhause.svg')}
                  className='ui fluid image'
                />
                Zu Hause bleiben: Gefährdete
              </div>
            </div>
          </div>
        </VerticalTimelineElement>

        <VerticalTimelineElement
          className='milestone'
          contentStyle={{ background: 'rgb(255, 255, 255)', color: '#333' }}
          contentArrowStyle={{ borderRight: '7px solid  rgb(255, 255, 255)' }}
          iconStyle={{ background: 'rgb(255, 255, 255)', color: '#fff' }}
          icon={<i className='icon dot circle large green' />}
        >
          <h3 className='vertical-timeline-element-title'>11. Mai</h3>
          <h4 className='vertical-timeline-element-subtitle'>
            Obligatorische Schulen, Einkaufsläden
          </h4>
          <p>
            Über die zweite Etappe will der Bundesrat am 29. April entscheiden.
          </p>
          <h5>
            <i className='icon lock open green opened' />
            Voraussichtlich geöffnet werden
          </h5>
          <div className='ui equal width center aligned padded grid'>
            <div className='row'>
              <div className='column'>
                <img
                  src={require('./images/schulen.svg')}
                  className='ui fluid image'
                />
                Obligatorische
                <br />
                Schulen*
              </div>
              <div className='column'>
                <img
                  src={require('./images/markt.svg')}
                  className='ui fluid image'
                />
                Alle Einkaufsläden
                <br />
                und Märkte
              </div>
            </div>
          </div>
          <p className='additional'>
            *Obligatorische Schulen: Primar- und Sekundarstufe I
          </p>
        </VerticalTimelineElement>

        <VerticalTimelineElement
          className='milestone'
          contentStyle={{ background: 'rgb(255, 255, 255)', color: '#333' }}
          contentArrowStyle={{ borderRight: '7px solid  rgb(255, 255, 255)' }}
          iconStyle={{ background: 'rgb(255, 255, 255)', color: '#fff' }}
          icon={<i className='icon dot circle large green' />}
        >
          <h3 className='vertical-timeline-element-title'>8. Juni</h3>
          <h4 className='vertical-timeline-element-subtitle'>
            Alle Schulen, Freizeitbetriebe
          </h4>
          <p>
            Über die dritte Etappe will der Bundesrat am 27. Mai entscheiden.
          </p>
          <h5>
            <i className='icon lock open green opened' />
            Voraussichtlich geöffnet werden
          </h5>
          <div className='ui equal width center aligned padded grid'>
            <div className='row'>
              <div className='column'>
                <img
                  src={require('./images/hochschulen.svg')}
                  className='ui fluid image'
                />
                Mittel-, Berufs- und Hochschulen
              </div>
              <div className='column'>
                <img
                  src={require('./images/museum.svg')}
                  className='ui fluid image'
                />
                Museen
              </div>
            </div>
            <div className='row'>
              <div className='column'>
                <img
                  src={require('./images/buecher.svg')}
                  className='ui fluid image'
                />
                Bibliotheken
              </div>
              <div className='column'>
                <img
                  src={require('./images/zoo.svg')}
                  className='ui fluid image'
                />
                Zoos, botanische Gärten
              </div>
            </div>
          </div>
          <p className='additional'>
            Das Versammlungsverbot plant der Bundesrat per 8. Juni zu lockern.
            Die Details will er am 27. Mai beschliessen. Für Restaurants und
            Bars gibt es noch keinen Fahrplan.
          </p>
        </VerticalTimelineElement>
      </VerticalTimeline>
      <div className='foot'>
        <p className='source'>
          Quelle: Bundesrat
          <br />
          Grafik: lm, Text: ffe
        </p>
        <hr />
        <p>
          <strong>Weitere Informationen</strong>
          <br />
          <a
            href='https://www.bag.admin.ch/bag/de/home/krankheiten/ausbrueche-epidemien-pandemien/aktuelle-ausbrueche-epidemien/novel-cov.html
'
            target='_blank'
          >
            Bundesamt für Gesundheit
          </a>
        </p>
      </div>
    </div>
  )
}
